import Vue from 'vue';

let state;

const getters = {
  'available-genres': (state, getters, rootState) => {
    return state.availableGenres;
  },
  'selected-genres': (state, getters, rootState) => {
    return state.selectedGenres;
  },
  'selected-genre-values': (state, getters, rootState) => {
    return state.selectedValues;
  },
};

const actions = {
  selectGenre({ commit }, genre) {
    if (genre.selected) {
      commit('addGenreToSelectedList', genre);
    } else {
      commit('removeGenreFromSelectedList', genre);
    }
    commit('updateSelectedGenreValues');
  },

  setAvailableGenres({ commit }, genres) {
    commit('saveAvailableGenres', genres);
  },

  setInitiallySelectedGenres({ commit }, genreIds){
    commit('saveInitiallySelectedGenres', genreIds);
    commit('updateSelectedGenreValues');
  },

  removeAllSelectedGenres({ commit }) {
    commit('removeAllSelectedGenres');
  },

  removeSelectedGenre({ commit }, genre) {
    commit('removeGenreFromSelectedList', genre);
    commit('updateSelectedGenreValues');
  },
};

const mutations = {
  addGenreToSelectedList(state, genre) {
    let genreIndex = state.selectedGenres.findIndex(elm => elm.value === genre.value);
    if (genreIndex !== -1) {
      return;
    }

    const hasSelectedChildren = !!genre.options.find(childGenre => childGenre.selected);
    if (hasSelectedChildren) {
      return;
    }

    state.selectedGenres.push(genre);
  },

  saveAvailableGenres(state, genres) {
    state.availableGenres = genres;
  },

  saveInitiallySelectedGenres(state, genreIds) {
    genreIds = genreIds.map(genreId => genreId.toString());
    selectNestedGenres(state, state.availableGenres, genreIds);
  },

  removeAllSelectedGenres(state) {
    removeSelectedGenres(state, state.selectedGenres);
    deselectRemovedGenres(state, state.availableGenres);

    state.selectedValues.value = '';
  },

  removeGenreFromSelectedList(state, genre) {
    removeSelectedGenres(state, genre.options);

    let genreIndex = state.selectedGenres.findIndex(elm => elm.value === genre.value);
    if (genreIndex === -1) {
      return;
    }

    state.selectedGenres.splice(genreIndex, 1);
    deselectRemovedGenres(state, state.availableGenres);
  },

  updateSelectedGenreValues(state) {
    let value = '';

    // Remove genres with selected children
    const previousGenres = state.selectedGenres;
    state.selectedGenres = [];
    previousGenres.forEach((genre) => {
      const hasSelectedChildren = !!genre.options.find(childGenre => childGenre.selected);
      if (hasSelectedChildren) {
        return;
      }

      state.selectedGenres.push(genre);
    });

    state.selectedGenres.forEach((genre) => {
      value += `,${ genre.value }`;
    });

    value = value.substring(1);
    state.selectedValues.value = value;
  },
};

function deselectRemovedGenres(state, genres) {
  if (!genres || !genres.length) {
    return;
  }

  genres.forEach((genre) => {
    deselectRemovedGenres(state, genre.options);

    const hasSelectedChildren = !!genre.options.find(childGenre => childGenre.selected);
    let genreIndex = state.selectedGenres.findIndex(elm => elm.value === genre.value);
    if (genreIndex === -1 && !hasSelectedChildren) {
      Vue.set(genre, 'selected', false);
    }
  });
}

function selectNestedGenres(state, genres, selectedGenreIds) {
  if (!genres || !genres.length) {
    return false;
  }

  let isSelected = false;

  genres.forEach((genre) => {
    const hasSelectedChildren = selectNestedGenres(state, genre.options, selectedGenreIds, true);

    if (selectedGenreIds.includes(genre.value.toString()) || hasSelectedChildren) {
      isSelected = true;

      if (genre.isLabel !== true) {
        Vue.set(genre, 'selected', true);
      }

      state.selectedGenres.push(genre);
    }
  });

  return isSelected;
}

function removeSelectedGenres(state, genres) {
  if (!genres || !genres.length) {
    return;
  }

  genres.forEach((genre) => {
    removeSelectedGenres(state, genre.options);

    let genreIndex = state.selectedGenres.findIndex(elm => elm.value === genre.value);
    if (genreIndex === -1) {
      return;
    }

    state.selectedGenres.splice(genreIndex, 1);
  });
}

export default class GenresStore {
  constructor() {
    state = {
      availableGenres: [],
      selectedGenres: [],
      selectedValues: {
        value: '',
      },
    };

    return {
      namespaced: true,
      state,
      getters,
      actions,
      mutations,
    };
  }
}
